[
	{
		"id": "x",
		"name": "X",
		"methods": ["browser"],
		"entry_url": "https://x.com/compose/post",
		"dynamic_host": false,
		"hosts": ["x.com"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 280,
					"transfer": "text",
					"selectors": ["[role=\"dialog\"] [data-testid=\"tweetTextarea_0\"][contenteditable=\"true\"]"],
					"format": "plain",
					"length_metric": "twitter"
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided",
				"max_count": 4,
				"video_alone": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
		"publication_hosts": ["x.com", "twitter.com"]
	},
	{
		"id": "linkedin",
		"name": "LinkedIn",
		"methods": ["browser"],
		"entry_url": "https://www.linkedin.com/sharing/compose",
		"dynamic_host": false,
		"hosts": ["linkedin.com"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "body",
					"label": ["Post", "动态"],
					"kind": "textarea",
					"required": true,
					"max_length": 3000,
					"transfer": "text",
					"selectors": ["[componentkey=\"ShareBox_textEditor\"]"],
					"format": "plain"
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided",
				"video_alone": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "linkedin-page",
		"name": "LinkedIn Page",
		"methods": ["browser"],
		"entry_url": "https://www.linkedin.com/company/",
		"dynamic_host": false,
		"hosts": ["linkedin.com"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "destination",
					"label": ["Page URL", "主页网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Post", "动态"],
					"kind": "textarea",
					"required": true,
					"max_length": 3000,
					"transfer": "text",
					"selectors": [".ql-editor[contenteditable=\"true\"]"],
					"format": "plain"
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided",
				"video_alone": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "reddit",
		"name": "Reddit",
		"methods": ["api", "browser"],
		"credential_provider": "reddit",
		"credential_kind": "oauth",
		"entry_url": "https://www.reddit.com/submit",
		"dynamic_host": false,
		"hosts": ["reddit.com"],
		"preview": {
			"layout": "discussion",
			"fields": [
				{
					"key": "community",
					"label": ["Community", "社区"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": 300,
					"transfer": "text",
					"selectors": ["textarea[name=\"title\"]", "input[name=\"title\"]"]
				},
				{
					"key": "body",
					"label": ["Text", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 10000,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][role=\"textbox\"]"],
					"format": "rich_text"
				},
				{
					"key": "flair",
					"label": ["Flair", "分类标签"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "nsfw",
					"label": ["Adult content", "成人内容"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["no", "yes"],
					"option_labels": {
						"no": ["No", "否"],
						"yes": ["Yes", "是"]
					}
				},
				{
					"key": "spoiler",
					"label": ["Spoiler", "剧透"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["no", "yes"],
					"option_labels": {
						"no": ["No", "否"],
						"yes": ["Yes", "是"]
					}
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "instagram",
		"name": "Instagram",
		"methods": ["browser"],
		"entry_url": "https://www.instagram.com/",
		"dynamic_host": false,
		"hosts": ["instagram.com"],
		"preview": {
			"layout": "gallery",
			"fields": [
				{
					"key": "body",
					"label": ["Caption", "说明"],
					"kind": "textarea",
					"required": true,
					"max_length": 2200,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][aria-label=\"Write a caption...\"]"],
					"format": "plain"
				},
				{
					"key": "alt",
					"label": ["Alternative text", "图片替代文本"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "location",
					"label": ["Location", "地点"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "collaborators",
					"label": ["Collaborators", "协作者"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": true,
				"multiple": true,
				"transfer": "guided",
				"max_count": 10
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "instagram-standalone",
		"name": "Instagram (Instagram Login)",
		"methods": ["browser"],
		"entry_url": "https://www.instagram.com/",
		"dynamic_host": false,
		"hosts": ["instagram.com"],
		"preview": {
			"layout": "gallery",
			"fields": [
				{
					"key": "body",
					"label": ["Caption", "说明"],
					"kind": "textarea",
					"required": true,
					"max_length": 2200,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][aria-label=\"Write a caption...\"]"],
					"format": "plain"
				},
				{
					"key": "alt",
					"label": ["Alternative text", "图片替代文本"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "location",
					"label": ["Location", "地点"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "collaborators",
					"label": ["Collaborators", "协作者"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": true,
				"multiple": true,
				"transfer": "guided",
				"max_count": 10
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "facebook",
		"name": "Facebook",
		"methods": ["browser"],
		"entry_url": "https://www.facebook.com/",
		"dynamic_host": false,
		"hosts": ["facebook.com"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "destination",
					"label": ["Page or profile URL", "主页或个人页网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 63206,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][role=\"textbox\"][data-lexical-editor=\"true\"]"],
					"format": "plain"
				},
				{
					"key": "audience",
					"label": ["Audience", "受众"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "threads",
		"name": "Threads",
		"methods": ["browser"],
		"entry_url": "https://www.threads.com/",
		"dynamic_host": false,
		"hosts": ["threads.com"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 500,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][role=\"textbox\"]"],
					"format": "plain"
				},
				{
					"key": "topic",
					"label": ["Topic", "话题"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "replies",
					"label": ["Who can reply", "谁可以回复"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "youtube",
		"name": "YouTube",
		"methods": ["api", "browser"],
		"credential_provider": "google-youtube",
		"credential_kind": "oauth",
		"entry_url": "https://studio.youtube.com/?d=ud",
		"dynamic_host": false,
		"hosts": ["studio.youtube.com"],
		"preview": {
			"layout": "video",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": 100,
					"transfer": "text",
					"selectors": ["#title-textarea #textbox"],
					"min_length": 2
				},
				{
					"key": "body",
					"label": ["Description", "说明"],
					"kind": "textarea",
					"required": true,
					"max_length": 5000,
					"transfer": "text",
					"selectors": ["#description-textarea #textbox"],
					"format": "plain"
				},
				{
					"key": "visibility",
					"label": ["Visibility", "可见性"],
					"kind": "select",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["public", "private", "unlisted"],
					"option_labels": {
						"public": ["Public", "公开"],
						"private": ["Private", "私密"],
						"unlisted": ["Unlisted", "不公开列出"]
					}
				},
				{
					"key": "kids",
					"label": ["Made for kids", "是否面向儿童"],
					"kind": "select",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "tags",
					"label": ["Tags", "标签"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "category",
					"label": ["Category", "类别"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "video/*",
				"required": true,
				"multiple": false,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
		"publication_hosts": ["youtube.com", "youtu.be"]
	},
	{
		"id": "gmb",
		"name": "Google Business Profile",
		"methods": ["browser"],
		"entry_url": "https://business.google.com/",
		"dynamic_host": false,
		"hosts": ["business.google.com"],
		"preview": {
			"layout": "business",
			"fields": [
				{
					"key": "destination",
					"label": ["Business dashboard URL", "商家管理页网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Update", "最新动态"],
					"kind": "textarea",
					"required": true,
					"max_length": 1500,
					"transfer": "guided",
					"selectors": [],
					"format": "plain"
				},
				{
					"key": "cta",
					"label": ["Action button", "行动按钮"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["NONE", "BOOK", "ORDER", "SHOP", "LEARN_MORE", "SIGN_UP", "GET_OFFER", "CALL"],
					"option_labels": {
						"NONE": ["None", "无"],
						"BOOK": ["Book", "预订"],
						"ORDER": ["Order online", "在线订购"],
						"SHOP": ["Buy", "购买"],
						"LEARN_MORE": ["Learn more", "了解详情"],
						"SIGN_UP": ["Sign up", "注册"],
						"GET_OFFER": ["Get offer", "领取优惠"],
						"CALL": ["Call now", "立即致电"]
					}
				},
				{
					"key": "link",
					"label": ["Button link", "按钮链接"],
					"kind": "url",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": false,
				"transfer": "guided",
				"no_video": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
		"publication_hosts": ["google.com", "maps.app.goo.gl"]
	},
	{
		"id": "tiktok",
		"name": "TikTok",
		"methods": ["browser"],
		"entry_url": "https://www.tiktok.com/tiktokstudio/upload",
		"dynamic_host": false,
		"hosts": ["tiktok.com"],
		"preview": {
			"layout": "video",
			"fields": [
				{
					"key": "body",
					"label": ["Caption", "说明"],
					"kind": "textarea",
					"required": true,
					"max_length": 2000,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][data-lexical-editor=\"true\"]"],
					"format": "plain"
				},
				{
					"key": "visibility",
					"label": ["Visibility", "可见性"],
					"kind": "select",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["public", "friends", "followers", "private"],
					"option_labels": {
						"public": ["Everyone", "所有人"],
						"friends": ["Friends", "好友"],
						"followers": ["Followers", "粉丝"],
						"private": ["Only you", "仅自己"]
					}
				},
				{
					"key": "comments",
					"label": ["Allow comments", "允许评论"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "duet",
					"label": ["Allow Duet", "允许合拍"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "stitch",
					"label": ["Allow Stitch", "允许拼接"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "ai_generated",
					"label": ["AI-generated content", "AI 生成内容"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "commercial",
					"label": ["Commercial content", "商业内容披露"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["none", "own_brand", "branded_content"],
					"option_labels": {
						"none": ["None", "无"],
						"own_brand": ["Your brand", "自有品牌"],
						"branded_content": ["Branded content", "品牌合作内容"]
					}
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": true,
				"multiple": true,
				"transfer": "guided",
				"video_alone": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "tiktok-business",
		"name": "TikTok Business",
		"methods": ["browser"],
		"entry_url": "https://www.tiktok.com/tiktokstudio/upload",
		"dynamic_host": false,
		"hosts": ["tiktok.com"],
		"preview": {
			"layout": "video",
			"fields": [
				{
					"key": "body",
					"label": ["Caption", "说明"],
					"kind": "textarea",
					"required": true,
					"max_length": 2200,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][data-lexical-editor=\"true\"]"],
					"format": "plain"
				},
				{
					"key": "visibility",
					"label": ["Visibility", "可见性"],
					"kind": "select",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["public", "friends", "followers", "private"],
					"option_labels": {
						"public": ["Everyone", "所有人"],
						"friends": ["Friends", "好友"],
						"followers": ["Followers", "粉丝"],
						"private": ["Only you", "仅自己"]
					}
				},
				{
					"key": "comments",
					"label": ["Allow comments", "允许评论"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "duet",
					"label": ["Allow Duet", "允许合拍"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "stitch",
					"label": ["Allow Stitch", "允许拼接"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "ai_generated",
					"label": ["AI-generated content", "AI 生成内容"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["yes", "no"],
					"option_labels": {
						"yes": ["Yes", "是"],
						"no": ["No", "否"]
					}
				},
				{
					"key": "commercial",
					"label": ["Commercial content", "商业内容披露"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["none", "own_brand", "branded_content"],
					"option_labels": {
						"none": ["None", "无"],
						"own_brand": ["Your brand", "自有品牌"],
						"branded_content": ["Branded content", "品牌合作内容"]
					}
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": true,
				"multiple": true,
				"transfer": "guided",
				"video_alone": true,
				"max_count": 35
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "pinterest",
		"name": "Pinterest",
		"methods": ["browser"],
		"entry_url": "https://www.pinterest.com/pin-creation-tool/",
		"dynamic_host": false,
		"hosts": ["pinterest.com"],
		"preview": {
			"layout": "pin",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": false,
					"max_length": 100,
					"transfer": "text",
					"selectors": ["textarea[id=\"pin-draft-title\"]"]
				},
				{
					"key": "body",
					"label": ["Description", "说明"],
					"kind": "textarea",
					"required": true,
					"max_length": 500,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][role=\"textbox\"]"],
					"format": "plain"
				},
				{
					"key": "link",
					"label": ["Destination link", "目标链接"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[id=\"pin-draft-link\"]"]
				},
				{
					"key": "board",
					"label": ["Board", "画板"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "alt",
					"label": ["Alternative text", "图片替代文本"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": true,
				"multiple": true,
				"transfer": "guided",
				"max_count": 5
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "dribbble",
		"name": "Dribbble",
		"methods": ["browser"],
		"entry_url": "https://dribbble.com/uploads/new",
		"dynamic_host": false,
		"hosts": ["dribbble.com"],
		"preview": {
			"layout": "gallery",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[name=\"title\"]"]
				},
				{
					"key": "body",
					"label": ["Description", "说明"],
					"kind": "textarea",
					"required": true,
					"max_length": 40000,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][role=\"textbox\"]"],
					"format": "plain"
				},
				{
					"key": "tags",
					"label": ["Tags", "标签"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "team",
					"label": ["Team", "团队"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": true,
				"multiple": false,
				"transfer": "guided",
				"no_video": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "discord",
		"name": "Discord",
		"methods": ["browser"],
		"entry_url": "https://discord.com/channels/@me",
		"dynamic_host": false,
		"hosts": ["discord.com"],
		"preview": {
			"layout": "chat",
			"fields": [
				{
					"key": "destination",
					"label": ["Channel URL", "频道网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Message", "消息"],
					"kind": "textarea",
					"required": true,
					"max_length": 1980,
					"transfer": "text",
					"selectors": ["[role=\"textbox\"][data-slate-editor=\"true\"]"],
					"format": "plain"
				}
			],
			"media": null
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "slack",
		"name": "Slack",
		"methods": ["browser"],
		"entry_url": "https://app.slack.com/",
		"dynamic_host": false,
		"hosts": ["app.slack.com"],
		"preview": {
			"layout": "chat",
			"fields": [
				{
					"key": "destination",
					"label": ["Channel URL", "频道网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Message", "消息"],
					"kind": "textarea",
					"required": true,
					"max_length": 400000,
					"transfer": "text",
					"selectors": ["[data-message-input=\"true\"] [contenteditable=\"true\"]"],
					"format": "plain"
				}
			],
			"media": null
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
		"publication_hosts": ["slack.com"]
	},
	{
		"id": "kick",
		"name": "Kick",
		"methods": ["browser"],
		"entry_url": "https://kick.com/",
		"dynamic_host": false,
		"hosts": ["kick.com"],
		"preview": {
			"layout": "chat",
			"fields": [
				{
					"key": "destination",
					"label": ["Channel URL", "直播频道网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Chat message", "聊天消息"],
					"kind": "textarea",
					"required": true,
					"max_length": 500,
					"transfer": "text",
					"selectors": ["#message-input"],
					"format": "plain"
				}
			],
			"media": null
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "twitch",
		"name": "Twitch",
		"methods": ["browser"],
		"entry_url": "https://www.twitch.tv/",
		"dynamic_host": false,
		"hosts": ["twitch.tv"],
		"preview": {
			"layout": "chat",
			"fields": [
				{
					"key": "destination",
					"label": ["Channel URL", "直播频道网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Chat message", "聊天消息"],
					"kind": "textarea",
					"required": true,
					"max_length": 500,
					"transfer": "text",
					"selectors": ["[data-a-target=\"chat-input\"]"],
					"format": "plain"
				},
				{
					"key": "messageType",
					"label": ["Message type", "消息类型"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["message", "announcement"],
					"option_labels": {
						"message": ["Chat message", "聊天消息"],
						"announcement": ["Announcement", "公告"]
					}
				},
				{
					"key": "announcementColor",
					"label": ["Announcement colour", "公告颜色"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"required_when": {
						"field": "messageType",
						"value": "announcement"
					},
					"options": ["primary", "blue", "green", "orange", "purple"],
					"option_labels": {
						"primary": ["Channel accent", "频道主色"],
						"blue": ["Blue", "蓝色"],
						"green": ["Green", "绿色"],
						"orange": ["Orange", "橙色"],
						"purple": ["Purple", "紫色"]
					}
				}
			],
			"media": null
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "mastodon",
		"name": "Mastodon",
		"methods": ["browser"],
		"entry_url": "https://mastodon.social/publish",
		"dynamic_host": true,
		"hosts": ["mastodon.social"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "destination",
					"label": ["Instance composer URL", "实例编辑页网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 500,
					"transfer": "text",
					"selectors": ["textarea.autosuggest-textarea__textarea"],
					"format": "plain"
				},
				{
					"key": "warning",
					"label": ["Content warning", "内容警告"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input.spoiler-input__input"]
				},
				{
					"key": "visibility",
					"label": ["Visibility", "可见性"],
					"kind": "select",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["public", "private", "unlisted"],
					"option_labels": {
						"public": ["Public", "公开"],
						"private": ["Followers only", "仅关注者"],
						"unlisted": ["Unlisted", "不公开列出"]
					}
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "bluesky",
		"name": "Bluesky",
		"methods": ["browser"],
		"entry_url": "https://bsky.app/",
		"dynamic_host": false,
		"hosts": ["bsky.app"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 300,
					"transfer": "text",
					"selectors": ["[data-testid=\"composerTextInput\"]"],
					"format": "plain"
				},
				{
					"key": "alt",
					"label": ["Alternative text", "图片替代文本"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "language",
					"label": ["Language", "语言"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided",
				"max_count": 4,
				"video_alone": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "lemmy",
		"name": "Lemmy",
		"methods": ["browser"],
		"entry_url": "https://lemmy.world/create_post",
		"dynamic_host": true,
		"hosts": ["lemmy.world"],
		"preview": {
			"layout": "discussion",
			"fields": [
				{
					"key": "destination",
					"label": ["Instance composer URL", "实例编辑页网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "community",
					"label": ["Community", "社区"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": 200,
					"transfer": "text",
					"selectors": ["textarea#post-title", "input#post-title"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 10000,
					"transfer": "text",
					"selectors": ["textarea#post-body"],
					"format": "markdown"
				},
				{
					"key": "link",
					"label": ["Link", "链接"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "nsfw",
					"label": ["Adult content", "成人内容"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["no", "yes"],
					"option_labels": {
						"no": ["No", "否"],
						"yes": ["Yes", "是"]
					}
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": false,
				"transfer": "guided",
				"no_video": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "wrapcast",
		"name": "Farcaster",
		"methods": ["browser"],
		"entry_url": "https://farcaster.xyz/",
		"dynamic_host": false,
		"hosts": ["farcaster.xyz"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "body",
					"label": ["Cast", "动态"],
					"kind": "textarea",
					"required": true,
					"max_length": 800,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][role=\"textbox\"]"],
					"format": "plain"
				},
				{
					"key": "channel",
					"label": ["Channel", "频道"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided",
				"no_video": true
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
		"publication_hosts": ["farcaster.xyz", "warpcast.com"]
	},
	{
		"id": "telegram",
		"name": "Telegram",
		"methods": ["browser"],
		"entry_url": "https://web.telegram.org/a/",
		"dynamic_host": false,
		"hosts": ["web.telegram.org"],
		"preview": {
			"layout": "chat",
			"fields": [
				{
					"key": "destination",
					"label": ["Web chat URL", "网页版聊天网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Message", "消息"],
					"kind": "textarea",
					"required": true,
					"max_length": 4096,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][role=\"textbox\"]"],
					"format": "plain"
				}
			],
			"media": null
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
		"publication_hosts": ["t.me", "telegram.me"]
	},
	{
		"id": "nostr",
		"name": "Nostr",
		"methods": ["browser"],
		"entry_url": "https://primal.net/",
		"dynamic_host": true,
		"hosts": ["primal.net"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "destination",
					"label": ["Web client URL", "网页客户端网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Note", "笔记"],
					"kind": "textarea",
					"required": true,
					"max_length": 100000,
					"transfer": "text",
					"selectors": ["textarea[placeholder=\"What’s on your mind?\"]"],
					"format": "plain"
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "vk",
		"name": "VK",
		"methods": ["browser"],
		"entry_url": "https://vk.com/feed",
		"dynamic_host": false,
		"hosts": ["vk.com"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "destination",
					"label": ["Community or profile URL", "社区或个人页网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 2048,
					"transfer": "text",
					"selectors": ["#post_field"],
					"format": "plain"
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "medium",
		"name": "Medium",
		"methods": ["browser"],
		"entry_url": "https://medium.com/new-story",
		"dynamic_host": false,
		"hosts": ["medium.com"],
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["h3[data-testid=\"editorTitleParagraph\"]"]
				},
				{
					"key": "body",
					"label": ["Story", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["div.section-inner .graf--p[contenteditable=\"true\"]"],
					"format": "rich_text"
				},
				{
					"key": "tags",
					"label": ["Topics", "主题"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "canonical",
					"label": ["Canonical URL", "原文地址"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
		"publication_custom_domain": true
	},
	{
		"id": "devto",
		"name": "DEV Community",
		"methods": ["browser"],
		"entry_url": "https://dev.to/new",
		"dynamic_host": false,
		"hosts": ["dev.to"],
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": 128,
					"transfer": "text",
					"selectors": ["textarea#article-form-title"]
				},
				{
					"key": "body",
					"label": ["Markdown", "Markdown 正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea#article_body_markdown"],
					"format": "markdown"
				},
				{
					"key": "tags",
					"label": ["Tags", "标签"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input#tag-input"]
				},
				{
					"key": "canonical",
					"label": ["Canonical URL", "原文地址"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input#canonicalUrl"]
				},
				{
					"key": "series",
					"label": ["Series", "系列"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "hashnode",
		"name": "Hashnode",
		"methods": ["browser"],
		"entry_url": "https://hashnode.com/draft",
		"dynamic_host": false,
		"hosts": ["hashnode.com"],
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea[placeholder=\"Article title…\"]"],
					"min_length": 6
				},
				{
					"key": "subtitle",
					"label": ["Subtitle", "副标题"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Article", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 10000,
					"transfer": "guided",
					"selectors": [],
					"format": "markdown"
				},
				{
					"key": "tags",
					"label": ["Tags", "标签"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "canonical",
					"label": ["Original article URL", "原文地址"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "publication",
					"label": ["Publication", "出版物"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
		"publication_custom_domain": true
	},
	{
		"id": "wordpress",
		"name": "WordPress",
		"methods": ["api"],
		"credential_provider": "wordpress-site",
		"credential_kind": "service_account",
		"entry_url": "https://wordpress.org/",
		"dynamic_host": true,
		"hosts": ["wordpress.org"],
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"min_length": 2
				},
				{
					"key": "body",
					"label": ["Article", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 100000,
					"transfer": "guided",
					"selectors": [],
					"format": "rich_text"
				},
				{
					"key": "excerpt",
					"label": ["Excerpt", "摘要"],
					"kind": "textarea",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "slug",
					"label": ["Slug", "网址别名"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "categories",
					"label": ["Category IDs", "分类 ID"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "tags",
					"label": ["Tag IDs", "标签 ID"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "status",
					"label": ["Publish status", "发布状态"],
					"kind": "select",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["draft", "pending", "publish", "private"],
					"option_labels": {
						"draft": ["Draft", "草稿"],
						"pending": ["Pending review", "待审核"],
						"publish": ["Publish publicly", "公开发布"],
						"private": ["Private", "私密"]
					}
				},
				{
					"key": "featured_media",
					"label": ["Featured media ID", "封面媒体 ID"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "listmonk",
		"name": "Listmonk",
		"methods": ["browser"],
		"entry_url": "https://listmonk.app/",
		"dynamic_host": true,
		"hosts": ["listmonk.app"],
		"preview": {
			"layout": "newsletter",
			"fields": [
				{
					"key": "destination",
					"label": ["Campaign editor URL", "邮件编辑页网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "title",
					"label": ["Campaign name", "邮件任务名称"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[name=\"name\"]"]
				},
				{
					"key": "subject",
					"label": ["Subject", "邮件主题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[name=\"subject\"]"]
				},
				{
					"key": "body",
					"label": ["Email body", "邮件正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"format": "rich_text"
				},
				{
					"key": "preview",
					"label": ["Preview text", "预览文字"],
					"kind": "textarea",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "list",
					"label": ["Recipient lists", "收件人列表"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "template",
					"label": ["Template", "模板"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "sender",
					"label": ["From address", "发件地址"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": null
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "moltbook",
		"name": "Moltbook",
		"methods": ["browser"],
		"entry_url": "https://www.moltbook.com/",
		"dynamic_host": false,
		"hosts": ["moltbook.com"],
		"preview": {
			"layout": "discussion",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[name=\"title\"]"]
				},
				{
					"key": "body",
					"label": ["Content", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 300,
					"transfer": "text",
					"selectors": ["textarea[name=\"content\"]"],
					"format": "markdown"
				},
				{
					"key": "community",
					"label": ["Submolt", "社区"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "whop",
		"name": "Whop",
		"methods": ["browser"],
		"entry_url": "https://whop.com/",
		"dynamic_host": false,
		"hosts": ["whop.com"],
		"preview": {
			"layout": "discussion",
			"fields": [
				{
					"key": "destination",
					"label": ["Community URL", "社区网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Content", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 50000,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][data-lexical-editor=\"true\"]"],
					"format": "markdown"
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "skool",
		"name": "Skool",
		"methods": ["browser"],
		"entry_url": "https://www.skool.com/",
		"dynamic_host": false,
		"hosts": ["skool.com"],
		"preview": {
			"layout": "discussion",
			"fields": [
				{
					"key": "destination",
					"label": ["Group URL", "小组网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[placeholder=\"Title\"]"]
				},
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 5000,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][data-placeholder=\"Write something...\"]"],
					"format": "markdown"
				},
				{
					"key": "category",
					"label": ["Category", "分类"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "mewe",
		"name": "MeWe",
		"methods": ["browser"],
		"entry_url": "https://mewe.com/myworld",
		"dynamic_host": false,
		"hosts": ["mewe.com"],
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "destination",
					"label": ["Group or profile URL", "群组或个人页网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 63206,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][data-placeholder=\"Tell your contacts what’s happening\"]"],
					"format": "plain"
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "tumblr",
		"name": "Tumblr",
		"methods": ["browser"],
		"entry_url": "https://www.tumblr.com/new/text",
		"dynamic_host": false,
		"hosts": ["tumblr.com"],
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Post", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 32768,
					"transfer": "text",
					"selectors": ["[contenteditable=\"true\"][role=\"textbox\"]"],
					"format": "rich_text"
				},
				{
					"key": "tags",
					"label": ["Tags", "标签"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "blog",
					"label": ["Blog", "博客"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "slug",
					"label": ["Custom URL", "自定义网址"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*,video/*",
				"required": false,
				"multiple": true,
				"transfer": "guided",
				"max_count": 30
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user"
		},
		"upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
	},
	{
		"id": "wechat",
		"name": "微信公众号",
		"entry_url": "https://mp.weixin.qq.com/",
		"hosts": ["mp.weixin.qq.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": 64,
					"transfer": "text",
					"selectors": ["#title"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": [
						"#ueditor_0 body[contenteditable=\"true\"]",
						"body.view[contenteditable=\"true\"]",
						".ProseMirror[contenteditable=\"true\"]"
					],
					"format": "rich_text"
				},
				{
					"key": "author",
					"label": ["Author", "作者"],
					"kind": "text",
					"required": false,
					"max_length": 8,
					"transfer": "text",
					"selectors": ["#author"]
				},
				{
					"key": "summary",
					"label": ["Summary", "摘要"],
					"kind": "textarea",
					"required": false,
					"max_length": 120,
					"transfer": "text",
					"selectors": ["#digest"]
				},
				{
					"key": "canonical",
					"label": ["Original link", "原文链接"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "text",
					"selectors": ["#js_content_source_url"]
				}
			],
			"media": {
				"accept": "image/*",
				"required": true,
				"multiple": false,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Sign in, then create a new article in the draft box. Fill the article with the assistant; select a cover, review originality and confirm publication in WeChat. Unattended publishing is not available.",
				"登录后在草稿箱新建图文，再用助手填入。封面必选，原创声明及群发确认需在公众号后台完成；暂不支持无人值守发布。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "zhihu",
		"name": "知乎",
		"entry_url": "https://zhuanlan.zhihu.com/write",
		"hosts": ["zhuanlan.zhihu.com"],
		"publication_hosts": ["www.zhihu.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea.WriteIndex-titleInput", "textarea[placeholder=\"请输入标题（最多 100 个字）\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": [
						".public-DraftEditor-content[contenteditable=\"true\"]",
						".ProseMirror[contenteditable=\"true\"]"
					],
					"format": "rich_text"
				},
				{
					"key": "topics",
					"label": ["Topics", "话题（在平台选择）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "column",
					"label": ["Column", "专栏（选填）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Sign in and open the article editor. Review the filled article, select topics and any column or cover, then confirm publication in Zhihu. Unattended publishing is not available.",
				"登录后打开写文章页面，核对填入的内容；话题、专栏和封面在知乎选择后确认发布。暂不支持无人值守发布。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "xiaohongshu",
		"name": "小红书",
		"entry_url": "https://creator.xiaohongshu.com/publish/publish?from=homepage&target=image",
		"hosts": ["creator.xiaohongshu.com"],
		"publication_hosts": ["www.xiaohongshu.com", "xiaohongshu.com", "xhslink.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": 20,
					"transfer": "text",
					"selectors": ["input[placeholder*=\"填写标题\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": 1000,
					"transfer": "text",
					"selectors": [".tiptap[contenteditable=\"true\"]", ".ql-editor[contenteditable=\"true\"]"],
					"format": "plain"
				},
				{
					"key": "topics",
					"label": ["Topics", "话题（在平台选择）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "location",
					"label": ["Location", "地点（选填）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": true,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"This flow creates an image note. Upload images first; once the editor appears, continue filling with the assistant. Review topics, cover and visibility before publishing. Unattended publishing is not available.",
				"当前支持图文笔记。先上传图片，编辑器出现后在助手中继续填入；话题、封面及可见范围在平台核对后发布。暂不支持无人值守发布。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "douyin",
		"name": "抖音",
		"entry_url": "https://creator.douyin.com/creator-micro/content/upload",
		"hosts": ["creator.douyin.com"],
		"publication_hosts": ["www.douyin.com", "v.douyin.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "video",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": 30,
					"transfer": "text",
					"selectors": ["input[placeholder*=\"填写作品标题\"]"]
				},
				{
					"key": "body",
					"label": ["Description", "作品描述"],
					"kind": "textarea",
					"required": false,
					"max_length": null,
					"transfer": "text",
					"selectors": ["div.zone-container[contenteditable=\"true\"]"]
				},
				{
					"key": "topics",
					"label": ["Topics", "话题（在平台选择）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "location",
					"label": ["Location", "地点（选填）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "video/*",
				"required": true,
				"multiple": false,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Upload one video first. Continue filling after processing; select the cover and review topics, visibility and any content declarations before publishing. Unattended publishing is not available.",
				"先上传一个视频，处理完成后继续填入标题和描述；在抖音核对封面、话题、可见范围及内容声明，再确认发布。暂不支持无人值守发布。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "bilibili",
		"name": "哔哩哔哩",
		"entry_url": "https://member.bilibili.com/platform/upload/video/frame",
		"hosts": ["member.bilibili.com"],
		"publication_hosts": ["www.bilibili.com", "b23.tv"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "video",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": 80,
					"transfer": "text",
					"selectors": [".video-title input", "input[placeholder=\"请输入稿件标题\"]"]
				},
				{
					"key": "body",
					"label": ["Description", "视频简介"],
					"kind": "textarea",
					"required": false,
					"max_length": 2000,
					"transfer": "text",
					"selectors": [".video-desc textarea", ".video-desc [contenteditable=\"true\"]"]
				},
				{
					"key": "category",
					"label": ["Category", "分区（在平台选择）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "tags",
					"label": ["Tags", "标签（在平台选择）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "copyright",
					"label": ["Copyright", "稿件类型"],
					"kind": "select",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["original", "repost"],
					"option_labels": {
						"original": ["Original", "自制"],
						"repost": ["Repost", "转载"]
					}
				},
				{
					"key": "source",
					"label": ["Source URL for reposts", "转载来源（转载时必填）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"required_when": {
						"field": "copyright",
						"value": "repost"
					}
				}
			],
			"media": {
				"accept": "video/*",
				"required": true,
				"multiple": false,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Upload one video, then continue filling. Category, tags and cover must be set in Bilibili; confirm original/repost and provide the source for reposts. Unattended publishing is not available.",
				"先上传一个视频，再继续填入。分区、标签、封面需在 B 站填写，核对自制／转载类型；转载必须补充来源。暂不支持无人值守发布。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "weibo",
		"name": "微博",
		"entry_url": "https://weibo.com/",
		"hosts": ["weibo.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "social",
			"fields": [
				{
					"key": "body",
					"label": ["Post", "微博正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea[placeholder=\"有什么新鲜事想分享给大家？\"]"],
					"format": "plain"
				},
				{
					"key": "topics",
					"label": ["Topics", "话题"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "audience",
					"label": ["Audience", "可见范围"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Sign in and open the post composer. Add images and choose topics and audience on Weibo. Review and publish on the platform; unattended publishing is unavailable.",
				"登录微博后打开发微博输入框；图片、话题及可见范围在微博设置。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "toutiao",
		"name": "今日头条",
		"entry_url": "https://mp.toutiao.com/profile_v4/graphic/publish",
		"hosts": ["mp.toutiao.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea[placeholder=\"请输入文章标题\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": [".ProseMirror[contenteditable=\"true\"]", ".ql-editor[contenteditable=\"true\"]"],
					"format": "rich_text"
				},
				{
					"key": "declaration",
					"label": ["Originality and sources", "原创声明与来源"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"This flow creates an article. Sign in to Toutiao, review the body, cover and originality declaration. Review and publish on the platform; unattended publishing is unavailable.",
				"此入口发布图文文章。登录头条号后核对正文，选择封面和原创声明。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native",
		"publication_hosts": ["toutiao.com"]
	},
	{
		"id": "baijiahao",
		"name": "百家号",
		"entry_url": "https://baijiahao.baidu.com/builder/rc/edit?type=news",
		"hosts": ["baijiahao.baidu.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[placeholder=\"请输入标题\"]", "textarea[placeholder=\"请输入标题\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["body.view[contenteditable=\"true\"]", ".ProseMirror[contenteditable=\"true\"]"],
					"format": "rich_text"
				},
				{
					"key": "category",
					"label": ["Category", "分类"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "declaration",
					"label": ["Originality and sources", "原创声明与来源"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Open the article editor and review images, cover, category and source declarations. Review and publish on the platform; unattended publishing is unavailable.",
				"此入口发布图文文章。选择图文编辑器，检查图片、封面、分类和来源声明。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native",
		"publication_hosts": ["baijiahao.baidu.com"]
	},
	{
		"id": "kuaishou",
		"name": "快手",
		"entry_url": "https://cp.kuaishou.com/article/publish/video",
		"hosts": ["cp.kuaishou.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "video",
			"fields": [
				{
					"key": "body",
					"label": ["Video description", "视频描述"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["div[contenteditable=\"true\"]"],
					"format": "plain"
				},
				{
					"key": "topics",
					"label": ["Topics", "话题"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "audience",
					"label": ["Audience", "可见范围"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "video/*",
				"required": true,
				"multiple": false,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Upload one video and wait for processing before continuing. Set the cover, topics and audience on Kuaishou. Upload videos over 20 MB directly from your computer. Review and publish on the platform; unattended publishing is unavailable.",
				"先上传单个视频，等待处理完成后继续填入描述。封面、话题及可见范围在快手设置；大于 20 MB 的视频请直接上传本地文件。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native",
		"publication_hosts": ["kuaishou.com", "v.kuaishou.com"]
	},
	{
		"id": "csdn",
		"name": "CSDN",
		"entry_url": "https://editor.csdn.net/md/",
		"hosts": ["editor.csdn.net"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea[placeholder=\"请输入文章标题\"]", "input[placeholder=\"请输入文章标题\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"format": "markdown"
				},
				{
					"key": "tags",
					"label": ["Article tags", "文章标签"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "category",
					"label": ["Column", "分类专栏"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "source",
					"label": ["Originality and source", "原创／转载及来源"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Use the Markdown editor. The title can be matched; copy the body from the assistant into the Markdown editor. Choose tags and originality/source in publication settings. Review and publish on the platform; unattended publishing is unavailable.",
				"使用 Markdown 编辑器。标题可匹配填入；正文请用助手复制后粘贴到 Markdown 编辑区，避免破坏编辑器状态。发布设置中选择标签和原创／转载来源。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native",
		"publication_hosts": ["blog.csdn.net"]
	},
	{
		"id": "juejin",
		"name": "稀土掘金",
		"entry_url": "https://juejin.cn/editor/drafts/new",
		"hosts": ["juejin.cn"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[placeholder=\"输入文章标题...\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"format": "markdown"
				},
				{
					"key": "category",
					"label": ["Category", "分类（在平台选择）"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "tags",
					"label": ["Tags", "标签（在平台选择）"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "summary",
					"label": ["Summary", "摘要"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Use the Markdown editor and paste the body from the assistant. Choose category and tags, and review the summary and cover before publishing. Review and publish on the platform; unattended publishing is unavailable.",
				"使用 Markdown 编辑器，正文通过助手复制粘贴；发布前在掘金选择分类和标签，并核对摘要与封面。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "segmentfault",
		"name": "SegmentFault",
		"entry_url": "https://segmentfault.com/write",
		"hosts": ["segmentfault.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[name=\"title\"]", "input[placeholder=\"标题\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea[name=\"text\"]"],
					"format": "markdown"
				},
				{
					"key": "tags",
					"label": ["Tags", "标签（在平台选择）"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "blog",
					"label": ["Blog", "所属专栏"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Open Write an article. If the body editor cannot be identified, copy Markdown from the assistant. Select tags and the blog on the platform. Review and publish on the platform; unattended publishing is unavailable.",
				"打开写文章页面。若正文编辑器无法识别，请使用助手复制 Markdown；标签及所属专栏在平台选择。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "jianshu",
		"name": "简书",
		"entry_url": "https://www.jianshu.com/writer",
		"hosts": ["www.jianshu.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "article",
			"fields": [
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["input[placeholder=\"请输入标题\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"format": "markdown"
				},
				{
					"key": "notebook",
					"label": ["Notebook", "文集（在平台选择）"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Choose a notebook and create a new article. This flow supplies Markdown: switch to the Markdown editor before pasting. Keep existing articles intact. Review and publish on the platform; unattended publishing is unavailable.",
				"先选择文集并新建文章。此流程使用 Markdown 正文，请切换到 Markdown 编辑器后粘贴；不要覆盖已有文章。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native",
		"publication_hosts": ["jianshu.com"]
	},
	{
		"id": "quora",
		"name": "Quora",
		"entry_url": "https://www.quora.com/",
		"hosts": ["www.quora.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "discussion",
			"fields": [
				{
					"key": "destination",
					"label": ["Question URL", "要回答的问题网址"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "body",
					"label": ["Answer", "回答正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": [".q-box[contenteditable=\"true\"]"],
					"format": "rich_text"
				},
				{
					"key": "credential",
					"label": ["Answer credential", "回答身份／资历"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Enter a question URL and click Answer on that question. Adapt the content into a relevant answer, then review images and answer credentials in Quora. Review and publish on the platform; unattended publishing is unavailable.",
				"填写具体问题网址，打开问题后点击 Answer。此流程用于回答问题，请先将内容改写为切题的回答；图片和身份信息在 Quora 核对。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native"
	},
	{
		"id": "substack",
		"name": "Substack",
		"entry_url": "https://substack.com/publish",
		"hosts": ["substack.com"],
		"methods": ["browser"],
		"dynamic_host": false,
		"preview": {
			"layout": "newsletter",
			"fields": [
				{
					"key": "destination",
					"label": ["Publication editor URL (*.substack.com/publish/…)", "刊物编辑页网址（*.substack.com/publish/…）"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": []
				},
				{
					"key": "title",
					"label": ["Title", "标题"],
					"kind": "text",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea[placeholder=\"Title\"]", "input[placeholder=\"Title\"]"]
				},
				{
					"key": "body",
					"label": ["Body", "正文"],
					"kind": "textarea",
					"required": true,
					"max_length": null,
					"transfer": "text",
					"selectors": [".tiptap[contenteditable=\"true\"]", ".ProseMirror[contenteditable=\"true\"]"],
					"format": "rich_text"
				},
				{
					"key": "subtitle",
					"label": ["Subtitle", "副标题"],
					"kind": "text",
					"required": false,
					"max_length": null,
					"transfer": "text",
					"selectors": ["textarea[placeholder=\"Subtitle\"]"]
				},
				{
					"key": "audience",
					"label": ["Audience", "免费／付费受众"],
					"kind": "select",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["everyone", "paid", "free"],
					"option_labels": {
						"everyone": ["Everyone", "所有读者"],
						"paid": ["Paid subscribers", "付费订阅者"],
						"free": ["Free subscribers", "免费订阅者"]
					}
				},
				{
					"key": "delivery",
					"label": ["Email and app delivery", "是否发送邮件和 App 通知"],
					"kind": "select",
					"required": true,
					"max_length": null,
					"transfer": "guided",
					"selectors": [],
					"options": ["web_only", "email_and_app"],
					"option_labels": {
						"web_only": ["Web only", "仅发布到网页"],
						"email_and_app": ["Email and app inbox", "同时发送邮件和 App 通知"]
					}
				}
			],
			"media": {
				"accept": "image/*",
				"required": false,
				"multiple": true,
				"transfer": "guided"
			}
		},
		"browser": {
			"verification": "needs_live_verification",
			"fill": "assisted",
			"final_action": "user",
			"instructions": [
				"Enter the new-article editor URL for your publication on substack.com. Choose the audience and explicitly review whether to send email and app notifications. Review and publish on the platform; unattended publishing is unavailable.",
				"填写自己刊物的新文章编辑页网址，仅支持 substack.com 域名。核对受众，并在发布时明确选择是否发送邮件和 App 通知。 请在平台核对并点击发布，暂不支持定时自动提交。"
			]
		},
		"upstream_ref": "ondit-native"
	}
]
